module.exports = __webpack_public_path__ + "img/about004.e5014242.png";